import { render } from "./gdfx.vue?vue&type=template&id=67af5e61&scoped=true&ts=true"
import script from "./gdfx.vue?vue&type=script&lang=ts"
export * from "./gdfx.vue?vue&type=script&lang=ts"

import "./gdfx.vue?vue&type=style&index=0&id=67af5e61&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67af5e61"]])

export default __exports__